import React, {useEffect} from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { 
  BrowserRouter, 
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes, } from "react-router-dom";
import { GoogleOAuthProvider } from '@react-oauth/google';
import packageJson from '../package.json';
import withClearCache from './ClearCache';
import * as Sentry from "@sentry/react";
// import { HttpClient, CaptureConsole } from "@sentry/integrations";
import { attachStoredContexts } from "./utils/sentryContext";
global.appVersion = packageJson.version;

const ClearCacheApp = withClearCache(App);
const sentryEnabled = process.env.REACT_APP_SENTRY_ENABLED || false;
const sentryDebugMode = process.env.REACT_APP_SENTRY_DEBUG_MODE === "true" || false;
const sentryDsn = process.env.REACT_APP_SENTRY_DSN || "";

// console.log("sentryEnabled :", sentryEnabled);
// console.log("typeof sentryEnabled :", typeof sentryEnabled);
// console.log("sentryEnabled is true :", sentryEnabled === "true");
// console.log("sentryDsn :", sentryDsn);
if(sentryEnabled === "true" && sentryDsn !== ""){
  console.log("Sentry is enabled");
  Sentry.init({
    debug: sentryDebugMode,
    environment: process.env.REACT_APP_ENVIRONMENT || "local",
    dsn: sentryDsn,
    // Increase normalization depth so nested objects in logs and extras are preserved.
    normalizeDepth: 5,
    integrations: [
      // send console.log, console.warn, and console.error calls as logs to Sentry
      // new CaptureConsole({levels:['info', 'warn', 'error', 'debug', 'assert']}),
      Sentry.captureConsoleIntegration({levels:['info', 'warn', 'error']}),
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled and 'tracesSampleRate' for finer control
      Sentry.browserTracingIntegration(),

      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      }),

      Sentry.replayIntegration(), 
      // This integration captures errors on failed requests from Fetch and XHR and attaches request and response information. to capture 'sendDefaultPii' should be true
      Sentry.httpClientIntegration({failedRequestStatusCodes:[[400, 401, 403, 404, 500, 502]]})
    ],
    // This option is required for capturing headers and cookies.
    sendDefaultPii:true,

    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 0.2, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    
    // Performance Monitoring - For finer control of sent transactions you can adjust this value, or use tracesSampler
    tracesSampleRate: 0.2, // Capture 100% of the transactions, reduce in production!
    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: [process.env.REACT_APP_API_URI, process.env.REACT_APP_GOOGLE_REDIRECT_URI],  // backend + frontend
    // tracePropagationTargets: [process.env.REACT_APP_API_URI, process.env.REACT_APP_GOOGLE_REDIRECT_URI],  // backend + frontend
    // Attach any contexts we cached from React providers.
    beforeSend: (event) => attachStoredContexts(event),
  });
}
else{
  console.log("Sentry is disabled");
}

ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
  <BrowserRouter>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      {/* {console.log('rendering in index.js...')} */}
      {/* <App /> */}
      <ClearCacheApp />
    </GoogleOAuthProvider>
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();